/**
 * OVERRIDE Register.jsx
 * REASON: Default Volto Register view does not get the original userschema.
 * SemanticUI-free located at the components folder.
 * To override it, override the @plone/volto one instead of
 * this one.
 */

import Register from '../../../../../components/Register/Register';

export default Register;
